module.exports = __webpack_public_path__ + "static/media/Novecentoslabwide-Normal-webfont.4ce1ae7d.woff2";